import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client'
import { FC, useEffect, useState } from 'react';
import powerBiService from '@/projects/platform/services/power-bi-report';
import { ReportResponse } from '../response/response';

type PowerBiReportProps = {
    reportName: string,
}


const PowerBiReports: FC<PowerBiReportProps> = ({ reportName }) => {

    const [zoomLevel, setZoomLevel] = useState(1);
    const [reportData, setReportData] = useState<ReportResponse | null>(null);
    const [activePage, setActivePage] = useState<String>("Dashboard");
    
    const handleResize = () => {
        const width = window.innerWidth;

        var newZoomLevel = width / 2400;
        
        if(activePage !== "Dashboard")
            newZoomLevel = (width / 2400)*1.62;

        setZoomLevel(newZoomLevel);
      };

    useEffect(() => {
    
        handleResize();
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [activePage]);


    useEffect(() => {
        setReportData(null);
        const loadReportData = async () => {
            let reportResponse;
            if (reportName === 'power-bi-sales-performance-report') {
                reportResponse = await powerBiService.getSalesPerformanceReport();
            } else if (reportName === 'power-bi-live-sales-report') {
                reportResponse = await powerBiService.getLiveSalesReport();
            } else if (reportName === 'power-bi-stock-report') {
                reportResponse = await powerBiService.getStockReportReport();
            } else if (reportName === 'power-bi-bonibi-report') {
                reportResponse = await powerBiService.getBonibiReport();
            } else if (reportName === 'power-bi-philip-morris-sales-report') {
                reportResponse = await powerBiService.getSalesPerformanceReportPm();
            }
            setReportData( reportResponse);
        };

        loadReportData();
    }, [reportName]);

    return (
        <>
            {reportData ?  (
                    <PowerBIEmbed
                        embedConfig={{
                            type: 'report',
                            id: reportData?.data?.embedReport.reportId,
                            embedUrl: reportData?.data?.embedReport.embedUrl,
                            accessToken: reportData?.data?.embedToken.token,
                            tokenType: models.TokenType.Embed,
                            settings: {

                                zoomLevel: zoomLevel,
                                panes: {
                                    filters: {
                                        expanded: false,
                                        visible: false
                                    }
                                },
                                background: models.BackgroundType.Default,
                            }
                        }}

                        eventHandlers={
                            new Map([
                                ['loaded', function () { console.log('Report loaded'); }],
                                ['rendered', function () { console.log('Report rendered'); }],
                                ['error', function (event: any) { console.log(event.detail); }],
                                ['visualClicked', () => console.log('visual clicked')],
                                ['pageChanged', (event: any) => {setActivePage(event.detail.newPage.displayName); }],
                            ])
                        }

                        cssClassName={"embed-container"}

                        getEmbeddedComponent={(embeddedReport: any) => {
                            // console.log(embeddedReport);
                        }}
                    />

            ) : null}
        </>
    );
}


export default PowerBiReports;